import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './horariosvalores_team_probeach.module.scss';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5516991207617';

const PERGUNTAS = [
    'Você já jogou vôlei ou vôlei de praia antes?',
    'Como você considera o seu nível hoje?',
];

const HORARIOS = [
    {
        nivel: 'Iniciantes',
        turmas: [
            { dia: 'Segunda-feira', hora: '18:30 às 19:30' },
            { dia: 'Sexta-feira', hora: '18:30 às 19:30' },
            { dia: 'Sábado', hora: '17:00' },
        ],
    },
    {
        nivel: 'Intermediários',
        turmas: [
            { dia: 'Segunda-feira', hora: '19:30 às 20:30' },
            { dia: 'Sexta-feira', hora: '19:30 às 20:30' },
            { dia: 'Sábado', hora: '16:00 às 17:00' },
        ],
    },
    {
        nivel: 'Avançados',
        turmas: [
            { dia: 'Quarta-feira', hora: '19:30 às 21:00' },
            { dia: 'Domingo', hora: '08:00' },
        ],
    },
];

function whatsappUrl(mensagem: string) {
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensagem)}`;
}

const Horarios_team_probeach: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <Link to="/team_probeach" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1 className={styles.title}>Horários</h1>
                </div>

                <section className={styles.section}>
                    <p className={styles.lead}>
                        Encontre a turma ideal no <strong>Pro Beach</strong>
                    </p>
                    <p className={styles.paragraph}>
                        Pra te conhecer melhor e indicar a turma certa, me conta:
                    </p>
                    <ul className={styles.perguntasList}>
                        {PERGUNTAS.map((pergunta) => (
                            <li key={pergunta}>{pergunta}</li>
                        ))}
                    </ul>
                    <p className={styles.paragraph}>
                        Os treinos são divididos por nível — <strong>Iniciante</strong>,{' '}
                        <strong>Intermediário</strong> e <strong>Avançado</strong> — para você
                        evoluir no seu ritmo.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Horários por nível</h2>
                    <div className={styles.horariosList}>
                        {HORARIOS.map((grupo) => (
                            <div key={grupo.nivel} className={styles.horarioGrupo}>
                                <h3 className={styles.nivelTitle}>{grupo.nivel}</h3>
                                <ul className={styles.turmasList}>
                                    {grupo.turmas.map((turma) => (
                                        <li
                                            key={`${grupo.nivel}-${turma.dia}-${turma.hora}`}
                                            className={styles.turmaItem}
                                        >
                                            <span className={styles.turmaDia}>{turma.dia}</span>
                                            <span className={styles.turmaHora}>{turma.hora}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </section>

                <div className={styles.ctaGroup}>
                    <a
                        href={whatsappUrl(
                            'Olá! Vim pelo Pro Beach e gostaria de saber qual turma combina com o meu nível.'
                        )}
                        className={styles.cta}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Quero a turma ideal — WhatsApp
                    </a>
                    <a
                        href={whatsappUrl(
                            'Olá! Vim pelo Pro Beach e gostaria de agendar uma aula experimental.'
                        )}
                        className={styles.ctaSecondary}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Agendar aula experimental
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Horarios_team_probeach;
